import previewPaneStore from '../store/Store';
export default function isPreviewPaneDisplayed() {
    return !!previewPaneStore.state;
}
export function isPreviewPaneDisplayedForAttachment(attachmentId) {
    return isPreviewPaneDisplayed() && previewPaneStore.state.attachmentId.Id === attachmentId;
}
//# sourceMappingURL=isPreviewPaneDisplayed.js.map